import { render, staticRenderFns } from "./CandidateTransactions.vue?vue&type=template&id=3dd1917e"
import script from "./CandidateTransactions.vue?vue&type=script&lang=js"
export * from "./CandidateTransactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports